declare namespace $ {

	export class $mol_svg_line extends $mol_svg {
		from( ): readonly(any)[]
		to( ): readonly(any)[]
		from_x( ): string
		from_y( ): string
		to_x( ): string
		to_y( ): string
		dom_name( ): string
		pos( ): readonly(any)[]
		attr( ): ({ 
			'x1': ReturnType< $mol_svg_line['from_x'] >,
			'y1': ReturnType< $mol_svg_line['from_y'] >,
			'x2': ReturnType< $mol_svg_line['to_x'] >,
			'y2': ReturnType< $mol_svg_line['to_y'] >,
		})  & ReturnType< $mol_svg['attr'] >
	}
	
}

//# sourceMappingURL=line.view.tree.d.ts.map